// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"dfe5a394","318":"84536c4b","707":"bef3fcc9","994":"d1bcf352"}[chunkId] + ".css";
};